import React from "react";
import ElementSpacer from "../../../Layout/Components/ElementSpacer";

type Props = {
  icon: JSX.Element;
  title: string;
  data: string | number | boolean;
};

export const TopicsListItemExtra: React.FC<Props> = props => (
  <span style={{ fontSize: "14px" }}>
    <ElementSpacer>
      {props.icon}
      <span>
        <strong>{props.data}</strong>&nbsp;{props.title}
      </span>
    </ElementSpacer>
  </span>
);
